import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/integration-setting`;

export const createOrUpdateIntegrationSetting = async (data) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/upsert`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const getIntegrationSettingByUser = async (search = "") => {
  const res = await axiosInstance.get(`${BASE_URL}/me`, {
    ...getAuthHeaders(),
    params: {
      search,
    },
  });

  return res.data;
};

export const deleteIntegrationSettingByUuid = async ({ uuid, deleteMode }) => {
  const params = new URLSearchParams();
  params.append("deleteMode", deleteMode);

  const res = await axiosInstance.delete(
    `${BASE_URL}/${uuid}?${params.toString()}`,
    getAuthHeaders(),
  );

  return res.data;
};

export const getIntegrationSettingByUuid = async (settingUuid) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/id/${settingUuid}`,
    getAuthHeaders(),
  );
  return res.data;
};
export const getConfigurations = async (settingUuid, teamId) => {
  const res = await axiosInstance.get(`${BASE_URL}/configurations`, {
    ...getAuthHeaders(),
    params: {
      settingId: settingUuid,
      ...(teamId && { teamId }),
    },
  });

  return res.data;
};

export const refreshIntegrationSettingAPI = async (settingId = null) => {
  const res = await axiosInstance.get(`${BASE_URL}/refresh`, {
    ...getAuthHeaders(),
    params: { ...(settingId && { settingId }) },
  });

  return res.data;
};

export const getIntegrationGroups = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/groups`, getAuthHeaders());
  return res.data;
};
 
export const getConversationsByIntegrationSettingId = async (
  integrationSettingId,
) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/conversations/${integrationSettingId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const sendMessage = async ({
  integrationSettingUuid,
  channelId,
  recipientId,
  message,
}) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/send-message`,
    { integrationSettingUuid, channelId, recipientId, message },
    getAuthHeaders(),
  );

  return res.data;
};

export const sendReply = async ({
  integrationSettingUuid,
  messageId,
  channelId,
  recipientId,
  message,
}) => {
  const res = await axiosInstance.post(
    `${BASE_URL}/conversation/reply`,
    { integrationSettingUuid, messageId, channelId, recipientId, message },
    getAuthHeaders(),
  );

  return res.data;
};
